import React from 'react';
import { connect } from 'react-redux';

import { CheckboxFieldWithoutForm } from 'src/components';
import { getSelectOptions } from 'src/reducers/selectOptions';
import MemoList from 'src/features/Memos';
import { getOptionLabel, getGroupFullPathName } from 'src/utils/Utils';
import { formatDate } from 'src/utils/Date';
import InvitationHint from 'src/features/EmployeeInvitations/components/InvitationHint';
import ChangedContext from '../ChangedContext';

class EmployeeTableRow extends React.Component {
  state = {
    showHint: false
  };

  handleClick = () => {
    this.setState({
      ...this.state,
      showHint: true
    });
  };

  hideHint = () => {
    this.setState({
      ...this.state,
      showHint: false
    });
  };

  render() {
    const { employee, clientEmploymentTypes, groups, positions } = this.props;

    return (
      <tr className="table-hover">
        <ChangedContext.Consumer>
          {({ isSelected, change }) => {
            const checked = isSelected(employee);
            return (
              <td
                className={`m-table-checkbox-${checked ? 'on' : 'off'} table-hover ${
                  employee.staffCode ? '' : 'u-cur-notallowed'
                }`}
                onClickCapture={() => (employee.staffCode ? change({ [employee.id]: !checked }) : this.handleClick())}
              >
                {this.state.showHint && (
                  <InvitationHint onClick={this.hideHint}>スタッフコードを入力してください</InvitationHint>
                )}
                <CheckboxFieldWithoutForm checked={checked} readOnly disabled={!employee.staffCode} />
              </td>
            );
          }}
        </ChangedContext.Consumer>
        <td>
          <MemoList employeeId={employee.id} />
        </td>
        <td>{employee.staffCode}</td>
        <td>{employee.lastName + employee.firstName}</td>
        <td>{getOptionLabel(employee.employmentTypeId)(clientEmploymentTypes)}</td>
        <td>{!!employee.groupId && <div>{getGroupFullPathName(groups, employee.groupId)}</div>}</td>
        <td>{getOptionLabel(employee.positionId)(positions)}</td>
        <td>{formatDate(employee.joinedOn)}</td>
      </tr>
    );
  }
}

export default connect(state => ({
  clientEmploymentTypes: getSelectOptions(state, 'employmentTypes'),
  groups: getSelectOptions(state, 'groups'),
  positions: getSelectOptions(state, 'positions')
}))(EmployeeTableRow);
